import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PDialogModule, PFieldModule, POtpInputModule, PSnackbarModule, PSpinnerModule } from '@frontend-site/ui/components';
import { TranslateModule } from '@ngx-translate/core';
import { PIconModule } from '@panaya/ui/p-icon';
import { PLinkModule } from '@panaya/ui/p-link';
import { PTooltipModule } from '@panaya/ui/p-tooltip';
import { PipeModule } from '@panaya/ui/pipes';
import { NgLetModule } from 'ng-let';
import { SwitchAccountDialogComponent } from './switch-account-dialog/switch-account-dialog.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { UserProfileDialogComponent } from './user-profile-dialog/user-profile-dialog.component';
import { ViewAllLicensesDialogComponent } from './view-all-licenses-dialog/view-all-licenses-dialog.component';
import { UserSecurityTabComponent } from './user-profile-dialog/security-tab/user-security-tab.component';
import { ChangePasswordDialogComponent } from './user-profile-dialog/change-password-dialog/change-password-dialog.component';
import { AddVerificationMethodDialogComponent } from './user-profile-dialog/add-verification-method-dialog/add-verification-method-dialog.component';
import { AuthenticatorSetupDialogComponent } from './user-profile-dialog/authenticator-setup-dialog/authenticator-setup-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        PDialogModule,
        PFieldModule,
        PipeModule,
        MatMenuModule,
        NgLetModule,
        PFieldModule,
        PDialogModule,
        PSnackbarModule,
        PLinkModule,
        PIconModule,
        MatTooltipModule,
        ReactiveFormsModule,
        FormsModule,
        PTooltipModule,
        MatTabsModule,
        POtpInputModule,
        PSpinnerModule
    ],
    exports: [UserMenuComponent],
    declarations: [
        UserMenuComponent,
        UserProfileDialogComponent,
        SwitchAccountDialogComponent,
        ViewAllLicensesDialogComponent,
        UserSecurityTabComponent,
        ChangePasswordDialogComponent,
        AddVerificationMethodDialogComponent,
        AuthenticatorSetupDialogComponent
    ]
})
export class UsersFeaturesModule {}
